import React from 'react';
import Form from 'antd/lib/form';
import Select from 'antd/lib/select';
import 'antd/lib/select/style/index.css';
var formStyles = require('src/imports/styles/extend.form.scss');
var InputGender = function (props) { return (React.createElement(Form.Item, { label: React.createElement("span", { className: formStyles.optional }, "Gender"), colon: false }, props.form.getFieldDecorator('gender', {
    initialValue: props.initialValue || '',
    rules: [{
            type: 'string',
        }, {
            whitespace: true,
        }],
})(React.createElement(Select, { size: 'large', allowClear: true, disabled: props.isDisabled },
    React.createElement(Select.Option, { value: 'female' }, "Female"),
    React.createElement(Select.Option, { value: 'male' }, "Male"))))); };
export default InputGender;



//////////////////
// WEBPACK FOOTER
// ./src/pages/WorkspaceEvent/FormAthletePage/FormAthlete/InputGender.tsx
// module id = 1201
// module chunks = 0